export const ADJUSTMENT_TYPES = [
  { value: "inventory_count", label: "Inventory count difference" },
  { value: "entry_error", label: "Entry error" },
  { value: "damage", label: "Damage / deterioration" },
  { value: "loss", label: "Loss / theft" },
  { value: "production_waste", label: "Production waste" },
  { value: "return", label: "Return" },
  { value: "measurement", label: "Weighing / measurement difference" },
  { value: "location", label: "Location correction" },
  { value: "other", label: "Other" },
];

export const adjustmentTypeLabel = (v: string) =>
  ADJUSTMENT_TYPES.find((t) => t.value === v)?.label ?? v;